import "../../css/App.css";
import "../../css/GlobalStyles.css";
import { memo, useCallback } from "react";
import { Event } from "@markit/common.types";
import { truncateString } from "../../utils/stringUtils";
import { useTheme } from "../../hooks/useTheme";
import { Colors } from "../../utils/colors";
import CustomLinkify from "../Links/CustomLinkify";
import { firebaseMapsApiKey } from "../../firebase";
import { Icon } from "@iconify/react";
import { isDesktop } from "react-device-detect";

type FullEventLocationPinProps = {
  event: Event;
  address: string;
  showCondensed?: boolean;
};

export const FullEventLocationPin = memo(function FullEventLocationPin(
  props: FullEventLocationPinProps
) {
  const { event, address, showCondensed } = props;
  const { theme } = useTheme();

  const openMapOnPress = useCallback(() => {
    window.open(
      "https://www.google.com/maps/search/?api=1&query=Google&query_place_id=" +
        event.googlePlaceId
    );
  }, [event.googlePlaceId]);

  return (
    <div className="ColumnNormal" style={{ gap: 14 }}>
      <div className="AlignedRow" style={{ gap: 14 }}>
        <div
          className="InfoContainerIcon"
          style={{
            ...theme.NewPrimaryBG,
            border: `0.5px solid ${theme.EditableTextFieldBorder.borderColor}`,
          }}
        >
          <Icon
            icon="mdi:map-marker"
            height={31}
            style={{ color: Colors.BLUE5 }}
          />
        </div>
        <div className="ColumnNormal">
          {event.isVirtual || event.privateLocation ? (
            <div className="ColumnNormal" style={{ gap: 4 }}>
              <span className="bodyBold" style={{ ...theme.PrimaryText }}>
                {event.isVirtual ? "Virtual" : "RSVP to view location"}
              </span>
              <span className="bodySubtext" style={{ ...theme.LabelText }}>
                {event.privateLocation && event.isVirtual
                  ? "This event is virtual"
                  : "The host has hidden the event location"}
              </span>
            </div>
          ) : (
            <div
              className="ColumnNormalSelect"
              style={{
                gap: 4,
                pointerEvents: event.privateLocation ? "none" : "auto",
              }}
              onClick={openMapOnPress}
            >
              <span className="bodyMedium" style={{ ...theme.PrimaryText }}>
                {truncateString(
                  event.googleDescription,
                  isDesktop ? 50 : 40,
                  "..."
                )}
              </span>
              <div className="AlignedRow" style={{ gap: "5px" }}>
                <span className="bodySubtext" style={{ ...theme.LabelText }}>
                  {truncateString(address, isDesktop ? 50 : 40, "...")}
                </span>
                <Icon
                  icon="ion:open-outline"
                  height={16}
                  style={{ ...theme.LabelText }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      {!showCondensed && !event.privateLocation ? (
        <>
          {event.locationDetails ? (
            <CustomLinkify>
              <div
                className="LocationDetails"
                style={{ ...theme.SubText, whiteSpace: "pre-wrap" }}
              >
                {event.locationDetails}
              </div>
            </CustomLinkify>
          ) : null}
          {!event.isVirtual ? (
            <div className="LocationContainer" onClick={openMapOnPress}>
              <img
                className="LocationSquare"
                src={
                  "https://maps.googleapis.com/maps/api/staticmap?center=" +
                  event.lat +
                  "," +
                  event.lng +
                  `&zoom=16&size=400x200&key=${firebaseMapsApiKey}`
                }
                alt="map"
              />
            </div>
          ) : null}
        </>
      ) : null}
    </div>
  );
});
